
import pdf_not_found from './radiation_field_guide/NotInRFG.pdf';
import pdf_AM_241 from './radiation_field_guide/RFG_AM_241.pdf';
import pdf_AMBE from './radiation_field_guide/RFG_AMBE.pdf';
import pdf_BA_133 from './radiation_field_guide/RFG_BA_133.pdf';
import pdf_C_14 from './radiation_field_guide/RFG_C_14.pdf';
import pdf_CD_109 from './radiation_field_guide/RFG_CD_109.pdf';
import pdf_CF_252 from './radiation_field_guide/RFG_CF_252.pdf';
import pdf_CO_57 from './radiation_field_guide/RFG_CO_57.pdf';
import pdf_CO_60 from './radiation_field_guide/RFG_CO_60.pdf';
import pdf_CR_51 from './radiation_field_guide/RFG_CR_51.pdf';
import pdf_CS_131 from './radiation_field_guide/RFG_CS_131.pdf';
import pdf_CS_137 from './radiation_field_guide/RFG_CS_137.pdf';
import pdf_DU from './radiation_field_guide/RFG_DU.pdf';
import pdf_F_18 from './radiation_field_guide/RFG_F_18.pdf';
import pdf_GA_67 from './radiation_field_guide/RFG_GA_67.pdf';
import pdf_GE_68 from './radiation_field_guide/RFG_GE_68.pdf';
import pdf_HEU from './radiation_field_guide/RFG_HEU.pdf';
import pdf_I_123 from './radiation_field_guide/RFG_I_123.pdf';
import pdf_I_124 from './radiation_field_guide/RFG_I_124.pdf';
import pdf_I_125 from './radiation_field_guide/RFG_I_125.pdf';
import pdf_I_131 from './radiation_field_guide/RFG_I_131.pdf';
import pdf_IN_111 from './radiation_field_guide/RFG_IN_111.pdf';
import pdf_IR_192_COMPTON from './radiation_field_guide/RFG_IR_192_COMPTON.pdf';
import pdf_IR_192 from './radiation_field_guide/RFG_IR_192.pdf';
import pdf_K_40 from './radiation_field_guide/RFG_K_40.pdf';
import pdf_KR_85 from './radiation_field_guide/RFG_KR_85.pdf';
import pdf_LA_138 from './radiation_field_guide/RFG_LA_138.pdf';
import pdf_LEU from './radiation_field_guide/RFG_LEU.pdf';
import pdf_LU_177 from './radiation_field_guide/RFG_LU_177.pdf';
import pdf_MEDICAL from './radiation_field_guide/RFG_MEDICAL.pdf';
import pdf_NEUTRONS from './radiation_field_guide/RFG_NEUTRONS.pdf';
import pdf_NP_237 from './radiation_field_guide/RFG_NP_237.pdf';
import pdf_P_32 from './radiation_field_guide/RFG_P_32.pdf';
import pdf_PD_103 from './radiation_field_guide/RFG_PD_103.pdf';
import pdf_PM_147 from './radiation_field_guide/RFG_PM_147.pdf';
import pdf_PO_210 from './radiation_field_guide/RFG_PO_210.pdf';
import pdf_PU_239 from './radiation_field_guide/RFG_PU_239.pdf';
import pdf_PU_240 from './radiation_field_guide/RFG_PU_240.pdf';
import pdf_PU from './radiation_field_guide/RFG_PU.pdf';
import pdf_RA_226 from './radiation_field_guide/RFG_RA_226.pdf';
import pdf_RGPU from './radiation_field_guide/RFG_RGPU.pdf';
import pdf_SB_124 from './radiation_field_guide/RFG_SB_124.pdf';
import pdf_SE_75 from './radiation_field_guide/RFG_SE_75.pdf';
import pdf_SM_153 from './radiation_field_guide/RFG_SM_153.pdf';
import pdf_SR_82 from './radiation_field_guide/RFG_SR_82.pdf';
import pdf_SR_89 from './radiation_field_guide/RFG_SR_89.pdf';
import pdf_SR_90 from './radiation_field_guide/RFG_SR_90.pdf';
import pdf_TC_99M from './radiation_field_guide/RFG_TC_99M.pdf';
import pdf_TH_232 from './radiation_field_guide/RFG_TH_232.pdf';
import pdf_TL_201 from './radiation_field_guide/RFG_TL_201.pdf';
import pdf_TL_204 from './radiation_field_guide/RFG_TL_204.pdf';
import pdf_U_235 from './radiation_field_guide/RFG_U_235.pdf';
import pdf_U_238 from './radiation_field_guide/RFG_U_238.pdf';
import pdf_U from './radiation_field_guide/RFG_U.pdf';
import pdf_WGPU from './radiation_field_guide/RFG_WGPU.pdf';
import pdf_XE_133 from './radiation_field_guide/RFG_XE_133.pdf';

function RFGPDFLookup(isotopeName: string) {

    switch (isotopeName) {
        case 'AM_241':
            return (pdf_AM_241);
        case 'AMBE':
            return (pdf_AMBE);
        case 'BA_133':
            return (pdf_BA_133);
        case 'C_14':
            return (pdf_C_14);
        case 'CD_109':
            return (pdf_CD_109);
        case 'CF_252':
            return (pdf_CF_252);
        case 'CO_57':
            return (pdf_CO_57);
        case 'CO_60':
            return (pdf_CO_60);
        case 'CR_51':
            return (pdf_CR_51);
        case 'CS_131':
            return (pdf_CS_131);
        case 'CS_137':
            return (pdf_CS_137);
        case 'DU':
            return (pdf_DU);
        case 'F_18':
            return (pdf_F_18);
        case 'GA_67':
            return (pdf_GA_67);
        case 'GE_68':
            return (pdf_GE_68);
        case 'HEU':
            return (pdf_HEU);
        case 'I_123':
            return (pdf_I_123);
        case 'I_124':
            return (pdf_I_124);
        case 'I_125':
            return (pdf_I_125);
        case 'I_131':
            return (pdf_I_131);
        case 'IN_111':
            return (pdf_IN_111);
        case 'IR_192_COMPTON':
            return (pdf_IR_192_COMPTON);
        case 'IR_192':
            return (pdf_IR_192);
        case 'K_40':
            return (pdf_K_40);
        case 'KR_85':
            return (pdf_KR_85);
        case 'LA_138':
            return (pdf_LA_138);
        case 'LEU':
            return (pdf_LEU);
        case 'LU_177':
            return (pdf_LU_177);
        case 'MEDICAL':
            return (pdf_MEDICAL);
        case 'NEUTRONS':
            return (pdf_NEUTRONS);
        case 'NP_237':
            return (pdf_NP_237);
        case 'P_32':
            return (pdf_P_32);
        case 'PD_103':
            return (pdf_PD_103);
        case 'PM_147':
            return (pdf_PM_147);
        case 'PO_210':
            return (pdf_PO_210);
        case 'PU_239':
            return (pdf_PU_239);
        case 'PU_240':
            return (pdf_PU_240);
        case 'PU':
            return (pdf_PU);
        case 'RA_226':
            return (pdf_RA_226);
        case 'RGPU':
            return (pdf_RGPU);
        case 'SB_124':
            return (pdf_SB_124);
        case 'SE_75':
            return (pdf_SE_75);
        case 'SM_153':
            return (pdf_SM_153);
        case 'SR_82':
            return (pdf_SR_82);
        case 'SR_89':
            return (pdf_SR_89);
        case 'SR_90':
            return (pdf_SR_90);
        case 'TC_99M':
            return (pdf_TC_99M);
        case 'TH_232':
            return (pdf_TH_232);
        case 'TL_201':
            return (pdf_TL_201);
        case 'TL_204':
            return (pdf_TL_204);
        case 'U_235':
            return (pdf_U_235);
        case 'U_238':
            return (pdf_U_238);
        case 'U':
            return (pdf_U);
        case 'WGPU':
            return (pdf_WGPU);
        case 'XE_133':
            return (pdf_XE_133);
        default:
            return (pdf_not_found);
    }

}

export default RFGPDFLookup
